__turbopack_context__.v({
  "className": "inter_2f6434ad-module__YwSlza__className",
  "variable": "inter_2f6434ad-module__YwSlza__variable",
});
